import {WebClient} from "../../store/clients/client";
import {SupportTicket} from "../../models/support";

// ---------------------------------------- ADMIN ----------------------------------------
export async function adminFetchSupportTicketsPaginated(page:number) {
    try {
        const response = await WebClient.AdminGetListSupportTickets(page);

        if (response.status === 200) {
            return response.data['results'] as SupportTicket[]
        }
    }catch (e) {}

    return [] as SupportTicket[];
}

export async function adminFetchSupportTicket(ticket:SupportTicket) : Promise<SupportTicket> {
    try {
        const response = await WebClient.AdminGetSupportTicket(ticket);

        if (response.status === 200) {
            return response.data as SupportTicket
        }
    }catch (e) {}

    return {} as SupportTicket;
}

export async function adminUpdateSupportTicket(ticket:SupportTicket) : Promise<SupportTicket> {
    try {
        const response = await WebClient.AdminUpdateSupportTicket(ticket);

        if (response.status === 200) {
            return response.data as SupportTicket
        }
    }catch (e) {}

    return {} as SupportTicket;
}

export async function adminDeleteSupportTicket(ticket:SupportTicket) : Promise<boolean> {
    try {
        const response = await WebClient.AdminDeleteSupportTicket(ticket);

        if (response.status === 204) {
            return true
        }
    }catch (e) {}

    return false;
}


// ---------------------------------------- USER ----------------------------------------
export async function newSupportTicket(ticket:SupportTicket|any) : Promise<SupportTicket> {
    try {
        const response = await WebClient.NewSupportTicket(ticket);

        if (response.status === 200) {
            return response.data as SupportTicket
        }
    }catch (e) {}

    return {} as SupportTicket;
}

export async function fetchSupportTicketsPaginated(page:number) {
    try {
        const response = await WebClient.GetListSupportTickets(page);

        if (response.status === 200) {
            return response.data['results'] as SupportTicket[]
        }
    }catch (e) {}

    return [] as SupportTicket[];
}

export async function fetchSupportTicket(ticket:SupportTicket) : Promise<SupportTicket> {
    try {
        const response = await WebClient.GetSupportTicket(ticket);

        if (response.status === 200) {
            return response.data as SupportTicket
        }
    }catch (e) {}

    return {} as SupportTicket;
}

export async function deleteSupportTicket(ticket:SupportTicket) : Promise<boolean> {
    try {
        const response = await WebClient.DeleteSupportTicket(ticket);

        if (response.status === 204) {
            return true
        }
    }catch (e) {}

    return false;
}
